module.exports = __webpack_public_path__ + "4763f8e5f2f60659556d7037dc981923.png";